import React from "react";
import SpecialistAssignmentBoard from "./SpecialistAssignmentBoard";
import FlowEngineGlobalGate from "../specialist-flow-engine/FlowEngineGlobalGate";

const SpecialistPreManagerSelectionScreen = () => {
  return (
    <FlowEngineGlobalGate>
      <SpecialistAssignmentBoard
        roleKey="pre-manager"
        titleKey="specialist.selection.pre-manager.title"
        defaultTitle="Bandeja del Pre-Gestor"
      />
    </FlowEngineGlobalGate>
  );
};

export default SpecialistPreManagerSelectionScreen;
